'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoViewer = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactRedux = require('react-redux');

var _navigation = require('program/frontend/actions/navigation');

var _tracking = require('program/frontend/actions/tracking');

var _reactYoutube = require('react-youtube');

var _reactYoutube2 = _interopRequireDefault(_reactYoutube);

var _flatIndex = require('program/flat-index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  root: {

    backgroundColor: "#222222",
    position: "absolute",
    top: 64,
    left: 0,
    right: 0,
    bottom: 0

  },

  video: {
    position: "absolute",
    top: 20,
    left: 20,
    right: 20,
    bottom: 20
  }

};

var playerOpts = {
  width: "100%",
  height: "100%",
  playerVars: {
    autoplay: 1,
    rel: 0
  }
};

var VideoViewer = _react2['default'].createClass({

  displayName: "VideoViewer",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  componentDidMount: function componentDidMount() {

    this.timer = setInterval(this.checkTime, 2000);
  },
  componentWillUnmount: function componentWillUnmount() {

    clearInterval(this.timer);
  },
  checkTime: function checkTime() {
    var _this = this;

    return (0, _asyncToGenerator3['default'])( /*#__PURE__*/_regenerator2['default'].mark(function _callee() {
      var _props, dispatch, params, videoId, pos;

      return _regenerator2['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.ytPlayer) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.prev = 2;
              _props = _this.props, dispatch = _props.dispatch, params = _props.params;
              videoId = params.videoId;
              _context.t0 = Math;
              _context.next = 8;
              return _this.ytPlayer.getCurrentTime();

            case 8:
              _context.t1 = _context.sent;
              pos = _context.t0.round.call(_context.t0, _context.t1);


              dispatch((0, _tracking.setVideoPosSeen)(videoId, pos));

              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t2 = _context['catch'](2);


              console.error(_context.t2);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 13]]);
    }))();
  },
  receivePlayerRef: function receivePlayerRef(player) {

    this.ytPlayer = player && player.internalPlayer;
  },
  handleEnd: function handleEnd() {
    var _props2 = this.props,
        dispatch = _props2.dispatch,
        params = _props2.params;
    var videoId = params.videoId;


    var list = _flatIndex.flatIndex.filter(function (x) {
      return !!x.videoId;
    });

    var idx = list.findIndex(function (x) {
      return x.videoId === videoId;
    });

    if (idx >= 0 && idx < list.length - 1) {

      dispatch((0, _navigation.navigateTo)("/v/" + encodeURIComponent(list[idx + 1].videoId)));
    } else {

      dispatch((0, _navigation.navigateTo)("/finish"));
    }
  },
  render: function render() {
    var params = this.props.params;
    var videoId = params.videoId;


    return _react2['default'].createElement(
      'div',
      { style: styles.root },
      _react2['default'].createElement(
        'div',
        { style: styles.video },
        _react2['default'].createElement(_reactYoutube2['default'], {
          ref: this.receivePlayerRef,
          containerClassName: 'youtubeResponsiveContainer',
          videoId: videoId,
          opts: playerOpts,
          onEnd: this.handleEnd
        })
      )
    );
  }
});

exports.VideoViewer = VideoViewer = (0, _reactRedux.connect)()(VideoViewer);

exports.VideoViewer = VideoViewer;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/video-viewer/index.jsx
// module id = 922
// module chunks = 0